import React, { useState, useMemo, useEffect } from "react";
import {
  ALL_USERS_AND_GROUPS_IN_SURVEY,
  SURVEY_STATISTICS,
  ALL_ASSIGNED_SURVEYS,
  ALL_HISTORY_SURVEYS,
  ALL_ASSIGNED_RECURRENCES_SURVEYS,
  ALL_SURVEYS_BY_USER_ROLE,
  SURVEYS_I_CAN_APPROVE,
  SURVEYS_BY_STATES_ID,
  SURVEY_BY_ID,
} from "../../GraphQL/Queries";
import {
  CHANGE_STATE_SURVEY,
  CLONE_SURVEY,
  ENCRIPT_PARAMETERS,
} from "../../GraphQL/Mutations";
import MaterialTable from "material-table";
import {
  GeneralStyle,
  Convention,
  ContentLoader,
  ActionTooltipContainer,
  ActionContainer,
  ACTIVATEBUTTON,
  useStyles,
  Hr,
  ContentCenterHorizontal,
} from "./SurveyList.styled";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { IconButton } from "@material-ui/core";
import AssignmentIcon from "@material-ui/icons/Assignment";
import { useMutation, useLazyQuery } from "@apollo/client";
import PointersLine from "../../components/Loaders/PointersLine/PointersLine";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { useHistory } from "react-router-dom";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import PortalModal from "../../Portals";
import { getStateLoginComplete } from "../../containers/LayoutHome/stateLogin";
import { Row, Col } from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import TablePagination from "@material-ui/core/TablePagination";
import ViewControlMenu from "../ViewControlMenu/ViewControlMenu";
import MenuManageSurveys from "../MenuManageSurveys/MenuManageSurveys";
import ModalConfirmAction from "../ModalConfirmAction/ModalConfirmAction";
import ModalShowErrors from "../ModalShowErrors/ModalShowErrors";
import ModalResumeModal from "../ModalResumeModal/ModalResumeModal";
import InfoIcon from "@material-ui/icons/Info";
import { GreenSwitch } from "../../helpers/greenSwitch";
import { AntSwitch } from "../../helpers/antSwitch";
import { ROLES } from "../../util/RolesConstants";
import PropTypes from "prop-types";
import { theme as themeConfig } from "../../themes/themes";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: themeConfig.neutral.gray[2500],
    color: "white",
    padding: "1em 1em 1em 0",
    border: `1px solid ${themeConfig.border.light}`,
  },
}))(Tooltip);

const StateTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: themeConfig.neutral.gray[1100],
    color: themeConfig.neutral.white,
    padding: "1em",
    textAlign: "center",
  },
}))(Tooltip);

const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const SurveyList = ({
  setShowSurveyCreationMain,
  formTrigger,
  activeMySurveys = false,
  activeMySurveysHistory = false,
  activeMySurveysRecurrent = false,
  showCards,
  setShowCards,
  activeApprovalsRequested,
  activeUnderApproval,
  activeAll,
  searchBy,
  surveyEdit,
  sortingColumns,
  itsSurvey = true,
}) => {
  const classes = useStyles();
  const [data, setData] = useState({});
  const [surveyList, setSurveyList] = useState([]);
  const [alert, setAlert] = useState(false);
  const [open, setOpen] = useState(false);
  const [rowDataPersistence, setRowDataPersistence] = useState();
  const [openActiveSurveyModal, setOpenActiveSurveyModal] = useState();
  const [onlyAssigned, setOnlyAssigned] = useState(false);
  const [onlyReviewWithComments, setOnlyReviewWithComments] = useState(false);
  const [showUsersAsnwered, setShowUsersAsnwered] = useState(0);
  const [openActiveSurveyModalError, setOpenActiveSurveyModalError] = useState(
    {}
  );
  const [statistics, setStatistics] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [dataValidationActive, setDataValidationActive] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorSelected, setAnchorSelected] = useState(null);
  const [openCloneSurveyModal, setOpenCloneSurveyModal] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const rowsPerPageOptions = useMemo(() => [5, 10, 20], []);
  const [allPages, setAllPages] = useState(null);
  const [startCursor, setStartCursor] = useState("");
  const [endCursor, setEndCursor] = useState("");
  const [activeAfter, setActiveAfter] = useState(false);
  const [activeBefore, setActiveBefore] = useState(false);
  const [encriptParameters] = useMutation(ENCRIPT_PARAMETERS);
  const [cloneSurvey] = useMutation(CLONE_SURVEY);
  const [idSurveySelect, setIdSurveySelect] = useState();
  const [dataSurvey, setDataSurvey] = useState();
  const [openDeleteModal, setOpenDeleteModal] = useState(null);
  const [openResumeAnswer, setOpenResumeAnswer] = useState(null);
  const user = useMemo(() => getStateLoginComplete(), []);
  const history = useHistory();
  const [changeStateSurvey] = useMutation(CHANGE_STATE_SURVEY);
  const [newSurveyState, setNewSurveyState] = useState();
  const [reloadSurveyList, setReloadSurveyList] = useState(false);
  const [rowDataChangeState, setRowDataChangeState] = useState();
  const [newOwner, setNewOwner] = useState();
  const [titleActivationDate, setTitleActivationDate] = useState();

  const [
    runQuerySurveysByUserRole,
    { loading: loadingFirst, error: errorFirst },
  ] = useLazyQuery(ALL_SURVEYS_BY_USER_ROLE, {
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      if (data) {
        setData({ ...data });
      } else {
        setData();
      }
    },
  });

  const [runQuerySurveysICanApprove, { loading: loadingSurveysICanApprove }] =
    useLazyQuery(SURVEYS_I_CAN_APPROVE, {
      fetchPolicy: "cache-and-network",
      onCompleted: (data) => {
        if (data) {
          setData({ ...data });
        } else {
          setData();
        }
      },
    });

  const [
    runQueryUnderApprovalSurveys,
    { loading: loadingUnderApprovalSurveys },
  ] = useLazyQuery(SURVEYS_BY_STATES_ID, {
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      if (data) {
        setData({ ...data });
      } else {
        setData();
      }
    },
  });

  const [getSurveyStatistics, { loading: loadingStatistics }] = useLazyQuery(
    SURVEY_STATISTICS,
    {
      fetchPolicy: "cache-and-network",
      onCompleted: (data) => {
        if (data.surveyStatistics.withError) {
          NotificationManager.error("Error to charge information", "", 8000);
        } else {
          setStatistics(data.surveyStatistics.outputData);
        }
      },
    }
  );

  const [
    runQueryAllAssignedSurveysAgent,
    { loading: loadingAgent, error: errorAgent },
  ] = useLazyQuery(ALL_ASSIGNED_SURVEYS, {
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      if (data) {
        setData({ ...data });
      } else {
        setData();
      }
    },
  });

  const [
    runQueryAllHistorySurveyAgent,
    { loading: loadingAgentHistory, error: errorAgentHistory },
  ] = useLazyQuery(ALL_HISTORY_SURVEYS, {
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      if (data) {
        setData({ ...data });
      } else {
        setData();
      }
    },
  });

  const [
    runQueryAllRecurrenceSurveyAgent,
    { loading: loadingAgentRecurrence, error: errorAgentRecurrence },
  ] = useLazyQuery(ALL_ASSIGNED_RECURRENCES_SURVEYS, {
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      if (data) {
        setData({ ...data });
      } else {
        setData();
      }
    },
  });

  const [runQueryUsersAndGroups] = useLazyQuery(
    ALL_USERS_AND_GROUPS_IN_SURVEY,
    {
      fetchPolicy: "cache-and-network",
      onCompleted: (data) => {
        handleUsersAndGroups(data);
      },
    }
  );
  const [runQueryQuestionList] = useLazyQuery(SURVEY_BY_ID, {
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      setDataValidationActive(data.surveyById);
      runQueryUsersAndGroups({
        variables: { surveyId: data.surveyById.idSurvey },
      });
    },
  });

  const [runQuerySurvey] = useLazyQuery(SURVEY_BY_ID, {
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      setDataSurvey({ ...data });
    },
  });

  useEffect(() => {
    if (dataSurvey) {
      setShowSurveyCreationMain({
        idSurvey: idSurveySelect,
        isIntegrated: false,
        isEditSurvey: true,
        isGlobal: dataSurvey?.isGlobal,
        isTemplate: dataSurvey?.isTemplate,
        show: true,
        dataEditSurvey: dataSurvey,
        OnlyAssigned: onlyAssigned,
        onlyReviewWithComments: onlyReviewWithComments,
      });
    }
  }, [dataSurvey, idSurveySelect]);

  useEffect(() => {
    if (activeAll || activeUnderApproval || activeApprovalsRequested) {
      setActiveAfter(false);
      setActiveBefore(false);
    }
  }, [activeAll, activeUnderApproval, activeApprovalsRequested, searchBy]);

  useEffect(() => {
    if (user) {
      if (user.roleId !== ROLES.AGENT && activeMySurveys === false) {
        if (activeAfter === false && activeBefore === false) {
          getAdminFirstSurveysBasedonTab();
        }
        if (activeAfter === true && activeBefore === false) {
          if (activeApprovalsRequested) {
            runQuerySurveysICanApprove({
              variables: {
                first: rowsPerPage,
                after: endCursor,
                surveyStateIds: [6],
                searchBy: searchBy,
              },
            });
          } else if (activeUnderApproval) {
            runQueryUnderApprovalSurveys({
              variables: {
                first: rowsPerPage,
                after: endCursor,
                surveyStateIds: [1, 6, 7],
                searchBy: searchBy,
              },
            });
          } else if (activeAll) {
            runQuerySurveysByUserRole({
              variables: {
                first: rowsPerPage,
                after: endCursor,
                searchBy: searchBy,
              },
            });
          }
        }
        if (activeAfter === false && activeBefore === true) {
          if (activeApprovalsRequested) {
            runQuerySurveysICanApprove({
              variables: {
                last: rowsPerPage,
                before: startCursor,
                surveyStateIds: [6],
                searchBy: searchBy,
              },
            });
          } else if (activeUnderApproval) {
            runQueryUnderApprovalSurveys({
              variables: {
                last: rowsPerPage,
                before: startCursor,
                surveyStateIds: [1, 6, 7],
                searchBy: searchBy,
              },
            });
          } else if (activeAll) {
            runQuerySurveysByUserRole({
              variables: {
                last: rowsPerPage,
                before: startCursor,
                searchBy: searchBy,
              },
            });
          }
        }
      } else if (
        (user.roleId === ROLES.AGENT || activeMySurveys === true) &&
        activeAfter === false &&
        activeBefore === false
      ) {
        if (activeMySurveysRecurrent) {
          runQueryAllRecurrenceSurveyAgent({
            variables: {
              first: rowsPerPage,
              searchBy: searchBy,
            },
          });
        } else if (activeMySurveysHistory) {
          runQueryAllHistorySurveyAgent({
            variables: {
              first: rowsPerPage,
              searchBy: searchBy,
            },
          });
        } else {
          runQueryAllAssignedSurveysAgent({
            variables: {
              first: rowsPerPage,
              searchBy: searchBy,
            },
          });
        }
      }
    }
  }, [
    user,
    activeAfter,
    activeBefore,
    activeApprovalsRequested,
    activeUnderApproval,
    activeAll,
    activeMySurveys,
    activeMySurveysRecurrent,
    formTrigger,
    activeMySurveysHistory,
    reloadSurveyList,
    rowsPerPage,
    searchBy,
  ]);

  useEffect(() => {
    if (data) {
      if (user.roleId !== ROLES.AGENT && activeMySurveys === false) {
        if (
          Array.isArray(data.allSurveysByUserRole?.nodes) &&
          data.allSurveysByUserRole?.nodes.length > 0
        ) {
          handleAssignAllSurveysByUserRole(data);
        } else if (
          Array.isArray(data.surveysICanApprove?.nodes) &&
          data.surveysICanApprove?.nodes.length > 0
        ) {
          handleAssignSurveysICanApprove(data);
        } else if (
          Array.isArray(data.surveysByStatesId?.nodes) &&
          data.surveysByStatesId?.nodes.length > 0
        ) {
          handleAssignSurveysByStatesId(data);
        } else {
          setSurveyList([]);
        }
      } else {
        if (!activeMySurveysRecurrent && !activeMySurveysHistory) {
          if (
            Array.isArray(data.allAssignedSurveys?.nodes) &&
            data.allAssignedSurveys?.nodes.length > 0
          ) {
            handleAssignMyAssignedSurveys(data);
          } else {
            setSurveyList([]);
          }
        } else if (activeMySurveysHistory) {
          if (
            Array.isArray(data.mySurveysHistory?.nodes) &&
            data.mySurveysHistory?.nodes.length > 0
          ) {
            handleAssignMySurveyHistory(data);
          } else {
            setSurveyList([]);
          }
        } else if (activeMySurveysRecurrent) {
          if (
            Array.isArray(data.allAsignedRecurrencesSurveys?.nodes) &&
            data.allAsignedRecurrencesSurveys?.nodes.length > 0
          ) {
            handleAssignMyRecurrentSurvey(data);
          } else {
            setSurveyList([]);
          }
        }
      }
    }
  }, [
    data,
    user,
    activeMySurveysRecurrent,
    activeMySurveys,
    runQueryAllRecurrenceSurveyAgent,
    searchBy,
    activeMySurveysHistory,
    reloadSurveyList,
  ]);

  useEffect(() => {
    if (surveyEdit) {
      handleEditSurvey({
        idSurvey: surveyEdit,
      });
    }
  }, [surveyEdit]);

  useEffect(() => {
    if (newSurveyState && rowDataChangeState) {
      let variable = {
        idSurvey: rowDataChangeState.idSurvey,
        newSurveyState: newSurveyState,
      };
      if (newSurveyState === 2) {
        variable.activateDate = new Date();
      }
      changeStateSurvey({
        variables: variable,
      }).then((value) => {
        setShowLoader(false);
        if (value.data.changeStateSurvey.withError !== true) {
          if (newSurveyState === 4) {
            surveyList.splice(
              surveyList.findIndex(
                (f) => f.idSurvey === rowDataChangeState.idSurvey
              ),
              1
            );
          } else {
            rowDataChangeState.idSurveyState = newSurveyState;
          }

          setReloadSurveyList(!reloadSurveyList);
        } else {
          setOpenActiveSurveyModalError({
            message: value?.data?.changeStateSurvey?.message
              ? value?.data?.changeStateSurvey?.message
              : "Error to activating the survey",
          });
        }
      });
    }
  }, [newSurveyState, rowDataChangeState]);

  useEffect(() => {
    if (activeMySurveysRecurrent) {
      setTitleActivationDate("Next Activation Date");
    } else {
      setTitleActivationDate("Activation Date");
    }
  }, [activeMySurveysRecurrent]);

  const handleUsersAndGroups = (item) => {
    let surveyComplete = true;
    let saveConfiguration =
      dataValidationActive?.tpsurveyConfigurationSurveys.filter((f) => {
        return f.field === "TextButtonSave";
      });

    if (dataValidationActive?.tpsurveyQuestionSurveys.length === 0) {
      setShowLoader(false);
      surveyComplete = false;
      NotificationManager.warning(
        "Please configure at least one question before activating your survey",
        "",
        8000
      );
    }
    if (
      saveConfiguration.length === 0 ||
      JSON.parse(saveConfiguration[0].jsonConfiguration).text === ""
    ) {
      setShowLoader(false);
      surveyComplete = false;
      NotificationManager.warning(
        "Please configure the save button before activating your survey",
        "",
        8000
      );
    }
    if (
      item.allUsersAndGroupsInSurvey.userNames.length === 0 &&
      item.allUsersAndGroupsInSurvey.groups == 0
    ) {
      setShowLoader(false);
      surveyComplete = false;
      NotificationManager.warning(
        "Please assign the survey to users",
        "",
        8000
      );
    }

    if (surveyComplete) {
      updateSurveyFn(rowDataPersistence, 2);
      setOpenActiveSurveyModal(null);
    }
  };

  let handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (!activeMySurveys) {
      if (newPage > page) {
        setActiveAfter(true);
        setActiveBefore(false);
      }
      if (newPage < page) {
        setActiveAfter(false);
        setActiveBefore(true);
      }
      setReloadSurveyList(!reloadSurveyList);
    } else {
      setActiveAfter(false);
      setActiveBefore(false);
    }
    if (
      activeMySurveys &&
      !activeMySurveysHistory &&
      !activeMySurveysRecurrent
    ) {
      if (newPage > page && endCursor) {
        runQueryAllAssignedSurveysAgent({
          variables: {
            first: rowsPerPage,
            after: endCursor,
            searchBy: searchBy,
          },
        });
      } else if (newPage < page && startCursor) {
        runQueryAllAssignedSurveysAgent({
          variables: {
            last: rowsPerPage,
            before: startCursor,
            searchBy: searchBy,
          },
        });
      }
    }
    if (activeMySurveysHistory) {
      if (newPage > page && endCursor) {
        runQueryAllHistorySurveyAgent({
          variables: {
            first: rowsPerPage,
            after: endCursor,
            searchBy: searchBy,
          },
        });
      } else if (newPage < page && startCursor) {
        runQueryAllHistorySurveyAgent({
          variables: {
            last: rowsPerPage,
            before: startCursor,
            searchBy: searchBy,
          },
        });
      }
    }
    if (activeMySurveysRecurrent) {
      if (newPage > page && endCursor) {
        runQueryAllRecurrenceSurveyAgent({
          variables: {
            first: rowsPerPage,
            after: endCursor,
            searchBy: searchBy,
          },
        });
      } else if (newPage < page && startCursor) {
        runQueryAllRecurrenceSurveyAgent({
          variables: {
            last: rowsPerPage,
            before: startCursor,
            searchBy: searchBy,
          },
        });
      }
    }
  };

  const handleChangeRowsPerPage = (event) => {
    let newRowsPerPage = event?.target?.value
      ? parseInt(event.target.value)
      : 10;
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  let handleAssignAllSurveysByUserRole = (data) => {
    if (data.allSurveysByUserRole) {
      setAllPages(data.allSurveysByUserRole.totalCount);
      if (data.allSurveysByUserRole.pageInfo.hasNextPage === true) {
        setEndCursor(data.allSurveysByUserRole.pageInfo.endCursor);
      }
      if (data.allSurveysByUserRole.pageInfo.hasPreviousPage === true) {
        setStartCursor(data.allSurveysByUserRole.pageInfo.startCursor);
      }
      let allSurveysByUserRole =
        Array.isArray(data.allSurveysByUserRole.nodes) &&
        data.allSurveysByUserRole.nodes.length > 0 &&
        data.allSurveysByUserRole.nodes.map((element) => ({ ...element }));
      if (allSurveysByUserRole) {
        setSurveyList(allSurveysByUserRole);
      } else {
        setSurveyList([]);
      }
    } else {
      setSurveyList([]);
    }
  };

  let handleAssignSurveysICanApprove = (data) => {
    if (data.surveysICanApprove) {
      setAllPages(data.surveysICanApprove.totalCount);
      if (data.surveysICanApprove.pageInfo.hasNextPage === true) {
        setEndCursor(data.surveysICanApprove.pageInfo.endCursor);
      }
      if (data.surveysICanApprove.pageInfo.hasPreviousPage === true) {
        setStartCursor(data.surveysICanApprove.pageInfo.startCursor);
      }
      let allSurveys =
        Array.isArray(data.surveysICanApprove.nodes) &&
        data.surveysICanApprove.nodes.length > 0 &&
        data.surveysICanApprove.nodes.map((element) => ({ ...element }));
      if (allSurveys) {
        setSurveyList(allSurveys);
      } else {
        setSurveyList([]);
      }
    } else {
      setSurveyList([]);
    }
  };

  let handleAssignSurveysByStatesId = (data) => {
    if (data.surveysByStatesId) {
      setAllPages(data.surveysByStatesId.totalCount);
      if (data.surveysByStatesId.pageInfo.hasNextPage === true) {
        setEndCursor(data.surveysByStatesId.pageInfo.endCursor);
      }
      if (data.surveysByStatesId.pageInfo.hasPreviousPage === true) {
        setStartCursor(data.surveysByStatesId.pageInfo.startCursor);
      }
      let allSurveys =
        Array.isArray(data.surveysByStatesId.edges) &&
        data.surveysByStatesId.edges.length > 0 &&
        data.surveysByStatesId.edges.map((element) => {
          return element.node;
        });
      if (allSurveys) {
        setSurveyList(allSurveys);
      } else {
        setSurveyList([]);
      }
    } else {
      setSurveyList([]);
    }
  };

  let handleAssignMyAssignedSurveys = (data) => {
    if (data.allAssignedSurveys) {
      setAllPages(data.allAssignedSurveys?.totalCount);
      if (data.allAssignedSurveys.pageInfo.hasNextPage === true) {
        setEndCursor(data.allAssignedSurveys?.pageInfo.endCursor);
      }
      if (data.allAssignedSurveys.pageInfo.hasPreviousPage === true) {
        setStartCursor(data.allAssignedSurveys?.pageInfo.startCursor);
      }
      let allSurveys = data.allAssignedSurveys.nodes.map((element) => ({ ...element }));
      if (allSurveys) {
        setSurveyList(allSurveys);
      } else {
        setSurveyList([]);
      }
    } else {
      setSurveyList([]);
    }
  };

  let handleAssignMySurveyHistory = (data) => {
    if (data.mySurveysHistory) {
      setAllPages(data.mySurveysHistory?.totalCount);
      if (data.mySurveysHistory.pageInfo.hasNextPage === true) {
        setEndCursor(data.mySurveysHistory?.pageInfo.endCursor);
      }
      if (data.mySurveysHistory.pageInfo.hasPreviousPage === true) {
        setStartCursor(data.mySurveysHistory?.pageInfo.startCursor);
      }
      let allSurveys = data.mySurveysHistory.nodes.map((element) => ({ ...element }));
      if (allSurveys) {
        setSurveyList(allSurveys);
      } else {
        setSurveyList([]);
      }
    } else {
      setSurveyList([]);
    }
  };

  let handleAssignMyRecurrentSurvey = (data) => {
    if (data.allAsignedRecurrencesSurveys) {
      setAllPages(data.allAsignedRecurrencesSurveys?.totalCount);
      if (data.allAsignedRecurrencesSurveys.pageInfo.hasNextPage === true) {
        setEndCursor(data.allAsignedRecurrencesSurveys.pageInfo.endCursor);
      }
      if (data.allAsignedRecurrencesSurveys.pageInfo.hasPreviousPage === true) {
        setStartCursor(data.allAsignedRecurrencesSurveys.pageInfo.startCursor);
      }
      let allSurveys = data.allAsignedRecurrencesSurveys.nodes.map((element) => ({ ...element }));
      if (allSurveys) {
        setSurveyList(allSurveys);
      } else {
        setSurveyList([]);
      }
    } else {
      setSurveyList([]);
    }
  };

  const getAdminFirstSurveysBasedonTab = () => {
    setPage(0);
    if (activeApprovalsRequested) {
      runQuerySurveysICanApprove({
        variables: {
          first: rowsPerPage,
          surveyStateIds: [6],
          searchBy: searchBy,
        },
      });
    } else if (activeUnderApproval) {
      runQueryUnderApprovalSurveys({
        variables: {
          first: rowsPerPage,
          surveyStateIds: [1, 6, 7],
          searchBy: searchBy,
        },
      });
    } else if (activeAll) {
      runQuerySurveysByUserRole({
        variables: {
          first: rowsPerPage,
          searchBy: searchBy,
        },
      });
    }
  };

  const encriptParametersSurvey = (
    idSurvey,
    preview,
    idSurveyScheduling,
    isAnonymous
  ) => {
    encriptParameters({
      variables: {
        idSurvey: idSurvey.toString(),
      },
    })
      .then(
        (value) => {
          const { encriptParameters } = value.data;
          generateLinkSurvey(
            encriptParameters,
            preview,
            idSurveyScheduling,
            isAnonymous
          );
        },
        () => {
          navigator.clipboard.writeText("");
          setAlert(false);
          handleClick();
        }
      )
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const generateLinkSurvey = (
    encriptParameters,
    preview,
    idSurveyScheduling,
    isAnonymous
  ) => {
    console.log(encriptParameters, preview, idSurveyScheduling, isAnonymous);
    localStorage.setItem("openSurveyDate", new Date());
    if (idSurveyScheduling) {
      localStorage.setItem("idSurveyScheduling", idSurveyScheduling);
    } else {
      localStorage.setItem("idSurveyScheduling", "");
    }
    history.push(
      `/FillOutSurvey?ParamToken=${encriptParameters}&Preview=${preview}&isAnonymous=${isAnonymous}`
    );
  };

  let handleClick = () => {
    setOpen(true);
  };

  let handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  let handleEditSurvey = (rowData) => {
    setIdSurveySelect(rowData?.idSurvey);
    runQuerySurvey({ variables: { idSurvey: rowData?.idSurvey } });
    setAnchorEl(null);
    setAnchorSelected(null);
  };

  let updateSurveyFn = (rowData, state) => {
    switch (state) {
      case 1:
        setNewSurveyState("PENDING_ACTIVATION");
        break;
      case 2:
        setNewSurveyState("ACTIVE");
        break;
      case 3:
        setNewSurveyState("DISABLED");
        break;
      case 4:
        setNewSurveyState("DELETED");
        break;
      case 5:
        setNewSurveyState("IN_CONSTRUCTION");
        break;
      case 6:
        setNewSurveyState("READY_FOR_APPROVAL");
        break;
      case 7:
        setNewSurveyState("REVIEWED_WITH_COMMENTS");
        break;
      default:
        break;
    }
    setRowDataChangeState(rowData);
  };

  let handleTitleIdSurveyState = (id) => {
    switch (id) {
      case 3:
        return "Disable";
      case 1:
        return "Approved - Pending Activation";
      case 2:
        return "Active";
      case 7:
        return "Reviewed with comments";
      case 5:
        return "In construction";
      case 6:
        return "Ready for approval";
      default:
        return "Deleted";
    }
  };

  let handleBackgroundIdSurveyState = (id) => {
    switch (id) {
      case 3:
        return themeConfig.text.disabled;
      case 1:
        return themeConfig.neutral.white;
      case 2:
        return themeConfig.status.successDark;
      case 7:
        return themeConfig.status.error;
      case 5:
        return themeConfig.primary.orange;
      case 6:
        return themeConfig.status.info;
      default:
        return "inherit";
    }
  };

  let toggleChecked = (rowData) => {
    updateSurveyFn(rowData, rowData.idSurveyState === 2 ? 3 : 2);
  };

  let deleteSurvey = (rowData) => {
    updateSurveyFn(rowData, 4);
    setOpenDeleteModal(null);
  };

  let activeSurvey = (rowData) => {
    if (rowData) {
      setShowLoader(true);
      setRowDataPersistence(rowData);
      runQueryQuestionList({ variables: { idSurvey: rowData.idSurvey } });
    }
  };

  let handleClickActions = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setAnchorSelected(rowData.idSurvey);
  };

  let handleCloseActions = () => {
    setAnchorEl(null);
    setAnchorSelected(null);
  };

  let handleClone = (rowData) => {
    if (rowData) {
      setOpenCloneSurveyModal(null);
    }
    cloneSurvey({
      variables: {
        surveyModel: {
          idSurvey: rowData.idSurvey,
          createUser: newOwner ? newOwner : "",
        },
      },
    })
      .then((value) => {
        setShowLoader(false);
        if (value.data.cloneSurvey !== -1) {
          if (value?.data?.cloneSurvey?.withError === false) {
            NotificationManager.success(
              "The clone of the survey has been successfully",
              "",
              5000
            );
          } else if (value?.data?.cloneSurvey?.withError === true) {
            NotificationManager.warning(
              value?.data?.cloneSurvey?.message,
              "",
              5000
            );
          }
          setReloadSurveyList(!reloadSurveyList);
        } else {
          NotificationManager.warning("Error to clone the survey", "", 5000);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let handleReview = (item) => {
    setOnlyReviewWithComments(true);
    handleEditSurvey(item);
  };

  const getInfoUsersAnswered = (idSurvey) => {
    setShowUsersAsnwered(idSurvey);
    getSurveyStatistics({
      variables: { surveyId: idSurvey },
    });
  };

  const getSurveyStatisticsCardView = (idSurvey) => {
    getSurveyStatistics({
      variables: { surveyId: idSurvey },
    });
  };

  const searchInRowData = (value, rowData) => {
    let dataInString = JSON.stringify(rowData);
    return dataInString.toLowerCase().indexOf(value) !== -1;
  };

  const showModalActiveSurveyError = () => {
    return (
      openActiveSurveyModalError.message && (
        <ModalShowErrors
          open={openActiveSurveyModalError}
          setOpen={setOpenActiveSurveyModalError}
        />
      )
    );
  };

  const showModalActiveSurvey = () => {
    return (
      openActiveSurveyModal && (
        <ModalConfirmAction
          title={"Are you sure you want to activate this survey?"}
          open={openActiveSurveyModal}
          setOpen={setOpenActiveSurveyModal}
          fn={activeSurvey}
        />
      )
    );
  };

  const showModalCloneSurvey = () => {
    return (
      openCloneSurveyModal && (
        <ModalConfirmAction
          title={"Are you sure you want to clone this survey?"}
          open={openCloneSurveyModal}
          setOpen={setOpenCloneSurveyModal}
          fn={handleClone}
          activeCloneCheckbox={true}
          setNewOwner={setNewOwner}
          newOwner={newOwner}
        />
      )
    );
  };

  const handlePreview = (rowData) => {
    let id = rowData?.idSurvey;
    encriptParametersSurvey(id, false, false);
  };

  const showDeleteModal = () => {
    return openDeleteModal ? (
      <ModalConfirmAction
        title={"Are you sure you want to delete this survey?"}
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        fn={deleteSurvey}
      />
    ) : null;
  };

  const showResumeModal = () => {
    return (
      openResumeAnswer && (
        <ModalResumeModal
          open={openResumeAnswer}
          setOpen={setOpenResumeAnswer}
        />
      )
    );
  };

  const getActionColumnWidgets = () => {
    return !activeMySurveys &&
      !activeMySurveysHistory &&
      !activeMySurveysRecurrent ? (
      <>
        <HtmlTooltip
          arrow
          placement="top"
          title={
            <ActionTooltipContainer>
              <Button className="tooltip-btn disabled-btn">Activate</Button>
              <label>Inactive survey</label>
              <Button className="tooltip-btn">Activate</Button>
              <label>Ready to activate</label>
              <GreenSwitch size="small" checked={false} />
              <label>Disable survey</label>
              <GreenSwitch size="small" checked={true} />
              <label>Enable survey</label>
            </ActionTooltipContainer>
          }
        >
          <div>
            <InfoIcon />
            <label>Actions</label>
          </div>
        </HtmlTooltip>
      </>
    ) : (
      <></>
    );
  };

  return (
    <GeneralStyle>
      {(((loadingFirst ||
        loadingUnderApprovalSurveys ||
        loadingSurveysICanApprove) &&
        !errorFirst &&
        !activeMySurveys) ||
        (loadingAgent && !errorAgent && activeMySurveys) ||
        (loadingAgentHistory &&
          !errorAgentHistory &&
          activeMySurveys &&
          activeMySurveysHistory) ||
        (loadingAgentRecurrence &&
          !errorAgentRecurrence &&
          activeMySurveys &&
          activeMySurveysRecurrent)) && (
        <Row>
          <Col md="12" className="d-flex justify-content-center">
            <PointersLine color={themeConfig.text.primary} />
          </Col>
        </Row>
      )}
      {((!loadingAgent && errorAgent && activeMySurveys) ||
        (!loadingAgentHistory && errorAgentHistory && activeMySurveysHistory) ||
        (!loadingAgentRecurrence &&
          errorAgentRecurrence &&
          activeMySurveysRecurrent) ||
        ((!loadingFirst ||
          !loadingUnderApprovalSurveys ||
          !loadingSurveysICanApprove) &&
          errorFirst &&
          !activeMySurveys)) && (
          <Row>
            <Col md="12" className="d-flex justify-content-center">
              <h1>Error :(</h1>
            </Col>
          </Row>
        )}

      {(((!loadingFirst ||
        !loadingUnderApprovalSurveys ||
        !loadingSurveysICanApprove) &&
        !activeMySurveys &&
        !errorFirst) ||
        (!loadingAgent && activeMySurveys && !errorAgent) ||
        (!loadingAgentHistory &&
          activeMySurveys &&
          activeMySurveysHistory &&
          !errorAgentHistory) ||
        (!loadingAgentRecurrence &&
          activeMySurveys &&
          activeMySurveysRecurrent &&
          !errorAgentRecurrence)) &&
        user &&
        user.roleId ? (
        <div>
          <Snackbar open={open} autoHideDuration={1200} onClose={handleClose}>
            {alert ? (
              <Alert onClose={handleClose} severity="success">
                The link was generated correctly
              </Alert>
            ) : (
              <Alert onClose={handleClose} severity="error">
                The link was not generated, please try again
              </Alert>
            )}
          </Snackbar>
          {!showCards && Array.isArray(surveyList) && surveyList.length > 0 && (
            <MaterialTable
              style={{
                boxShadow: "none",
                marginLeft: "20px",
                marginRight: "20px",
              }}
              title=""
              columns={[
                {
                  title: "Survey ID",
                  field: "idSurvey",
                  customFilterAndSearch: (value, rowData) =>
                    searchInRowData(value, rowData),
                  type: "string",
                  sorting: sortingColumns,
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "Name",
                  field: "surveyName",
                  type: "string",
                  sorting: sortingColumns,
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "Description",
                  field: "surveyDescription",
                  type: "string",
                  sorting: sortingColumns,
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: titleActivationDate,
                  field: "activateSurveyDate",
                  type: "datetime",
                  sorting: sortingColumns,
                  cellStyle: {
                    padding: "0px 16px",
                  },
                  render: (rowData) => {
                    if (rowData?.activateSurveyDate) {
                      return (
                        <div>
                          {moment(
                            rowData?.activateSurveyDate,
                            "YYYY-MM-DD hh:mm a"
                          ).format("YYYY-MM-DD")}
                        </div>
                      );
                    } else {
                      return <div>-</div>;
                    }
                  },
                },
                {
                  title: "Created by",
                  field: "createUser",
                  type: "string",
                  sorting: sortingColumns,
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "State",
                  field: "idSurveyState",
                  type: "string",
                  width: "20px",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                  render: (rowData) => {
                    return (
                      <StateTooltip
                        arrow
                        placement="right"
                        title={handleTitleIdSurveyState(rowData?.idSurveyState)}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            className="point"
                            style={{
                              border: `${rowData?.idSurveyState === 1
                                ? `1px solid ${themeConfig.status.successDark}`
                                : "none"
                                }`,
                              background: `${handleBackgroundIdSurveyState(
                                rowData?.idSurveyState
                              )}`,
                              height: "1em",
                              width: "1em",
                              borderRadius: "7px",
                            }}
                          ></div>
                        </div>
                      </StateTooltip>
                    );
                  },
                },
                {
                  title: "Go To Survey",
                  field: "internal_action",
                  sorting: sortingColumns,
                  cellStyle: {
                    padding: "0px 16px",
                  },
                  render: (rowData) => {
                    if (
                      (rowData &&
                        !activeMySurveysRecurrent &&
                        !activeMySurveysHistory) ||
                      (activeMySurveysRecurrent && !activeMySurveysHistory)
                    ) {
                      return (
                        <div>
                          {rowData?.goToSurveyInfo?.goToSurvey && (
                            <IconButton
                              onClick={() => {
                                encriptParametersSurvey(
                                  rowData?.idSurvey,
                                  true,
                                  rowData?.goToSurveyInfo?.schedule
                                    ?.idSurveyScheduling,
                                  rowData?.isAnonymous
                                );
                              }}
                            >
                              <AssignmentIcon style={{ color: themeConfig.primary.blue }} />
                            </IconButton>
                          )}

                          {!rowData?.goToSurveyInfo?.goToSurvey && (
                            <IconButton disabled={true}>
                              <AssignmentIcon />
                            </IconButton>
                          )}
                        </div>
                      );
                    } else {
                      return (
                        <div>
                          {!activeMySurveysRecurrent &&
                            !activeMySurveysHistory &&
                            !rowData?.activateSurveyDate && (
                              <IconButton
                                onClick={() => {
                                  encriptParametersSurvey(
                                    rowData?.idSurvey,
                                    true,
                                    false,
                                    rowData?.isAnonymous
                                  );
                                }}
                              >
                                <AssignmentIcon style={{ color: themeConfig.primary.blue }} />
                              </IconButton>
                            )}
                          {!activeMySurveysRecurrent &&
                            !activeMySurveysHistory &&
                            rowData?.activateSurveyDate &&
                            ""}
                        </div>
                      );
                    }
                  },
                },
                {
                  title: "View Answer",
                  field: "internal_action",
                  sorting: sortingColumns,
                  cellStyle: {
                    padding: "0px 16px",
                  },
                  render: (rowData) => {
                    return (
                      <div>
                        {rowData?.hasAnswerPreview && (
                          <IconButton
                            onClick={() => {
                              setOpenResumeAnswer(rowData?.idSurvey);
                            }}
                          >
                            <VisibilityIcon style={{ color: themeConfig.primary.blue }} />
                          </IconButton>
                        )}
                        {!rowData?.hasAnswerPreview &&
                          activeMySurveysHistory === true && (
                            <IconButton
                              disabled={true}
                              onClick={() => {
                                setOpenResumeAnswer(rowData?.idSurvey);
                              }}
                            >
                              <VisibilityIcon />
                            </IconButton>
                          )}
                      </div>
                    );
                  },
                },
                {
                  title: getActionColumnWidgets(),
                  field: "internal_actions",
                  sorting: false,
                  cellStyle: {
                    padding: "0px 16px",
                  },
                  render: (rowData) =>
                    rowData && (
                      <ActionContainer>
                        {!activeMySurveys &&
                          !activeMySurveysHistory &&
                          !activeMySurveysRecurrent && (
                            <FormControlLabel
                              control={
                                <AntSwitch
                                  size="small"
                                  disabled={
                                    (rowData?.idSurveyState === 1 &&
                                      rowData?.idSurveyState) ||
                                      (rowData?.idSurveyState === 7 &&
                                        rowData?.idSurveyState) ||
                                      (rowData?.idSurveyState === 5 &&
                                        rowData?.idSurveyState) ||
                                      (rowData?.idSurveyState === 6 &&
                                        rowData?.idSurveyState)
                                      ? true
                                      : false
                                  }
                                  checked={
                                    (rowData?.idSurveyState === 1 &&
                                      rowData?.idSurveyState) ||
                                      (rowData?.idSurveyState === 3 &&
                                        rowData?.idSurveyState) ||
                                      (rowData?.idSurveyState === 7 &&
                                        rowData?.idSurveyState) ||
                                      (rowData?.idSurveyState === 5 &&
                                        rowData?.idSurveyState) ||
                                      (rowData?.idSurveyState === 6 &&
                                        rowData?.idSurveyState)
                                      ? false
                                      : true
                                  }
                                  onChange={() => toggleChecked(rowData)}
                                />
                              }
                            />
                          )}
                        {!activeMySurveys &&
                          !activeMySurveysHistory &&
                          !activeMySurveysRecurrent &&
                          !activeApprovalsRequested && (
                            <div style={{ paddingLeft: "12px" }}>
                              <ACTIVATEBUTTON
                                onClick={() =>
                                  setOpenActiveSurveyModal(rowData)
                                }
                                disabled={rowData?.idSurveyState !== 1}
                              >
                                Activate
                              </ACTIVATEBUTTON>
                            </div>
                          )}
                        {!activeMySurveys &&
                          !activeMySurveysHistory &&
                          !activeMySurveysRecurrent &&
                          activeApprovalsRequested && (
                            <div style={{ paddingLeft: "12px" }}>
                              <ACTIVATEBUTTON
                                onClick={() => handleReview(rowData)}
                              >
                                Review
                              </ACTIVATEBUTTON>
                            </div>
                          )}
                        {!activeMySurveys && (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Tooltip title="Actions">
                              <IconButton
                                aria-label="more"
                                aria-controls="long-menu"
                                aria-haspopup="true"
                                className={classes.active}
                                onClick={(e) => handleClickActions(e, rowData)}
                              >
                                <MoreVertIcon />
                              </IconButton>
                            </Tooltip>
                            <MenuManageSurveys
                              item={rowData}
                              anchorSelected={anchorSelected}
                              anchorEl={anchorEl}
                              handleCloseActions={handleCloseActions}
                              handleEditSurvey={handleEditSurvey}
                              setAnchorEl={setAnchorEl}
                              setAnchorSelected={setAnchorSelected}
                              setOpenDeleteModal={setOpenDeleteModal}
                              setOpenCloneSurveyModal={setOpenCloneSurveyModal}
                              setOnlyAssigned={setOnlyAssigned}
                              setOpenActiveSurveyModal={
                                setOpenActiveSurveyModal
                              }
                              handlePreview={handlePreview}
                              itsSurvey={itsSurvey}
                            />
                          </div>
                        )}

                        {!activeMySurveys &&
                          !activeMySurveysHistory &&
                          !activeMySurveysRecurrent && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <ClickAwayListener
                                onClickAway={() => {
                                  if (showUsersAsnwered === rowData.idSurvey) {
                                    setShowUsersAsnwered(0);
                                  }
                                }}
                              >
                                <HtmlTooltip
                                  arrow
                                  open={
                                    showUsersAsnwered === rowData.idSurvey
                                      ? true
                                      : false
                                  }
                                  placement="left"
                                  PopperProps={{
                                    disablePortal: true,
                                  }}
                                  disableFocusListener
                                  disableHoverListener
                                  disableTouchListener
                                  title={
                                    <>
                                      {loadingStatistics ? (
                                        <p
                                          style={{
                                            padding: "1em",
                                            margin: "0",
                                            listStyleType: "circle",
                                            lineHeight: "1.3",
                                            fontSize: "13px",
                                          }}
                                        >
                                          {" "}
                                          Loading...{" "}
                                        </p>
                                      ) : (
                                        <ul
                                          style={{
                                            margin: "0",
                                            listStyleType: "circle",
                                            lineHeight: "1.3",
                                            fontSize: "13px",
                                            textAlign: "left",
                                          }}
                                        >
                                          <li
                                            style={{
                                              listStyleType:
                                                "disclosure-closed",
                                            }}
                                          >{`Assigned Users: ${statistics.usersAssigned}`}</li>
                                          <li
                                            style={{
                                              listStyleType:
                                                "disclosure-closed",
                                            }}
                                          >{`Pending users to answer: ${statistics.surveysRemaining}`}</li>
                                          <li
                                            style={{
                                              listStyleType:
                                                "disclosure-closed",
                                            }}
                                          >{`Have answer: ${statistics.surveysResponded}`}</li>
                                        </ul>
                                      )}
                                    </>
                                  }
                                >
                                  <InfoIcon
                                    style={{
                                      cursor: "pointer",
                                      color: themeConfig.text.primary,
                                    }}
                                    onClick={() => {
                                      getInfoUsersAnswered(rowData.idSurvey);
                                    }}
                                  />
                                </HtmlTooltip>
                              </ClickAwayListener>
                            </div>
                          )}
                      </ActionContainer>
                    ),
                },
              ]
                .map((item) => ({ ...item }))
                .filter((item) => {
                  if (activeMySurveys === false) {
                    if (user && user.roleId !== ROLES.AGENT) {
                      return (
                        item.title !== "Go To Survey" &&
                        item.title !== "View Answer"
                      );
                    } else if (
                      user &&
                      (user.roleId === ROLES.SUPERVISOR ||
                        user.roleId === ROLES.WELLNESS_PROFESSIONAL)
                    ) {
                      return item.title !== "";
                    } else if (user && user.roleId === ROLES.AGENT) {
                      return (
                        item.title !== "Actions" &&
                        item.title !== "Disable" &&
                        item.title !== "State" &&
                        item.field !== "InfoAnswered"
                      );
                    }
                  } else {
                    if (activeMySurveysHistory === true) {
                      return (
                        item.title !== "Actions" &&
                        item.title !== "Disable" &&
                        item.title !== "State" &&
                        item.title !== "Go To Survey" &&
                        item.field !== "InfoAnswered"
                      );
                    } else {
                      return (
                        item.title !== "Actions" &&
                        item.title !== "Disable" &&
                        item.title !== "State" &&
                        item.title !== "View Answer" &&
                        item.field !== "InfoAnswered"
                      );
                    }
                  }
                })}
              data={surveyList}
              options={{
                maxBodyHeight: 550,
                paging: false,
                filtering: false,
                sorting: true,
                search: false,
                headerStyle: {
                  zIndex: 1,
                  fontWeight: "bold",
                  width: "calc(13px) !important",
                },
              }}
            ></MaterialTable>
          )}
          {showCards && Array.isArray(surveyList) && surveyList.length > 0 &&
            !loadingFirst &&
            !loadingUnderApprovalSurveys &&
            !loadingSurveysICanApprove && (
              <ViewControlMenu
                identity={
                  activeMySurveys ? "survey-list" : "survey-list-manage"
                }
                title={""}
                showCards={showCards}
                setShowCards={setShowCards}
                list={surveyList}
                isApprovalsRequested={activeApprovalsRequested}
                isAgent={activeMySurveys}
                isHistory={activeMySurveysHistory}
                isRecurrent={activeMySurveysRecurrent}
                toggleChecked={toggleChecked}
                handleClickActions={handleClickActions}
                anchorSelected={anchorSelected}
                anchorEl={anchorEl}
                handleCloseActions={handleCloseActions}
                handleEditSurvey={handleEditSurvey}
                setAnchorEl={setAnchorEl}
                setAnchorSelected={setAnchorSelected}
                setOpenDeleteModal={setOpenDeleteModal}
                setOpenCloneSurveyModal={setOpenCloneSurveyModal}
                setOnlyAssigned={setOnlyAssigned}
                handleReview={handleReview}
                encriptParametersSurvey={encriptParametersSurvey}
                openActiveSurveyModal={openActiveSurveyModal}
                setOpenActiveSurveyModal={setOpenActiveSurveyModal}
                activeSurvey={activeSurvey}
                setOpenResumeAnswer={setOpenResumeAnswer}
                statistics={{
                  data: statistics,
                  getSurveyStatistics: getSurveyStatisticsCardView,
                  loading: loadingStatistics,
                }}
                handlePreview={handlePreview}
                itsSurvey={itsSurvey}
              />
            )}
          <Row style={{ backgroundColor: themeConfig.neutral.white, margin: "0" }}>
            <Hr />
            <Col md="12">
              {user &&
                !loadingFirst &&
                !loadingUnderApprovalSurveys &&
                !loadingSurveysICanApprove &&
                user.roleId !== ROLES.AGENT &&
                activeMySurveys === false && (
                  <Convention>
                    <ContentCenterHorizontal>
                      <div
                        style={{
                          background: themeConfig.status.successDark,
                          height: "1em",
                          width: "1em",
                          borderRadius: "7px",
                        }}
                      ></div>
                      <p>Active</p>
                    </ContentCenterHorizontal>
                    <ContentCenterHorizontal>
                      <div
                        style={{
                          background: themeConfig.primary.orange,
                          height: "1em",
                          width: "1em",
                          borderRadius: "7px",
                        }}
                      ></div>
                      <p>In construction</p>
                    </ContentCenterHorizontal>
                    {itsSurvey === true ? (
                      <ContentCenterHorizontal>
                        <div
                          style={{
                            background: themeConfig.status.info,
                            height: "1em",
                            width: "1em",
                            borderRadius: "7px",
                          }}
                        ></div>
                        <p>Ready for approval</p>
                      </ContentCenterHorizontal>
                    ) : (
                      <></>
                    )}
                    {itsSurvey === true ? (
                      <ContentCenterHorizontal>
                        <div
                          style={{
                            background: themeConfig.neutral.white,
                            height: "1em",
                            width: "1em",
                            borderRadius: "7px",
                            border: `1px solid ${themeConfig.status.successDark}`,
                          }}
                        ></div>
                        <p>Approved - Pending Activation</p>
                      </ContentCenterHorizontal>
                    ) : (
                      <></>
                    )}
                    {itsSurvey === true ? (
                      <ContentCenterHorizontal>
                        <div
                          style={{
                            background: themeConfig.status.error,
                            height: "1em",
                            width: "1em",
                            borderRadius: "7px",
                          }}
                        ></div>
                        <p>Reviewed with comments</p>
                      </ContentCenterHorizontal>
                    ) : (
                      <></>
                    )}
                    <ContentCenterHorizontal>
                      <div
                        style={{
                          background: themeConfig.text.disabled,
                          height: "1em",
                          width: "1em",
                          borderRadius: "7px",
                        }}
                      ></div>
                      <p>Disable</p>
                    </ContentCenterHorizontal>
                  </Convention>
                )}
            </Col>
            <Col md="12">
              {allPages > 0 && rowsPerPage && rowsPerPageOptions ? (
                <TablePagination
                  component="div"
                  style={{
                    display: "flex",
                    justifyContent: !activeMySurveys ? "center" : "flex-end",
                    marginRight: "1em",
                    marginTop: !activeMySurveys ? "1em" : "0em",
                  }}
                  count={allPages}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  rowsPerPageOptions={rowsPerPageOptions}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              ) : (
                ""
              )}
            </Col>
          </Row>
        </div>
      ) : null}
      {showDeleteModal()}
      {showModalActiveSurvey()}
      {showModalCloneSurvey()}
      {showModalActiveSurveyError()}
      {showResumeModal()}
      {showLoader && (
        <PortalModal>
          <ContentLoader>
            <PointersLine color={themeConfig.text.primary}></PointersLine>
          </ContentLoader>
        </PortalModal>
      )}
    </GeneralStyle>
  );
};

export default SurveyList;

SurveyList.propTypes = {
  setShowSurveyCreationMain: PropTypes.func,
  formTrigger: PropTypes.string,
  activeMySurveys: PropTypes.bool,
  activeMySurveysHistory: PropTypes.bool,
  activeMySurveysRecurrent: PropTypes.bool,
  showCards: PropTypes.bool,
  setShowCards: PropTypes.func,
  activeApprovalsRequested: PropTypes.bool,
  activeUnderApproval: PropTypes.bool,
  activeAll: PropTypes.bool,
  searchBy: PropTypes.string,
  surveyEdit: PropTypes.number,
  sortingColumns: PropTypes.bool,
  itsSurvey: PropTypes.bool,
};
